import React, { useContext, useState } from "react";
import Edit from "../../../../../../components/SVGComponents/KeyImage/Edit";
import Delete from "../../../../../../components/SVGComponents/KeyImage/Delete";
import Save from "../../../../../../components/SVGComponents/KeyImage/Save";
import Revert from "../../../../../../components/SVGComponents/KeyImage/Revert";
import Clear from "../../../../../../components/SVGComponents/KeyImage/Clear";
import { useFormik } from "formik";
import { KeyImageSchema } from "../../../../../../Schemas/KeyImageSchema";
import ATextField from "../../../../../../components/ATextField";
import ConfirmModal from "../../../../../../components/Modal/ConfirmModal";
import { useTranslation } from "react-i18next";
import { deleteKeyImages, isKeyImageTitleAlreadyPresent, saveKeyImages } from "../../../../helpers/KeyImageUtility";
import studyviewerContext from "../../../../../../context/studyviewer/StudyviewerContext";
import studyReportContext from "../../../../../../context/studyreport/StudyReportContext";
import { isMobile } from "react-device-detect";

const ManageKeyImageRow = (props) => {
  const [isEditable, setIsEditable] = useState(false);
  const { keyImages, setKeyImages } = useContext(studyviewerContext);
  const [showDeleteConfirmDialog, setShowDeleteConfirmDialog] = useState(false);
  const {setAlertSuccessModal,alertSuccessModal} = useContext(studyReportContext);
  const imageTitle = props.keyImage?.keyImageTitle;
  const { t } = useTranslation();
  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    resetForm,
  } = useFormik({
    enableReinitialize: true,
    initialValues: { imageTitle },
    validationSchema: KeyImageSchema,
    onSubmit: async (values, action) => {
      if (isKeyImageTitleAlreadyPresent(keyImages, values.imageTitle)) {
        console.log("is key submitted")
        // props.setShowDialogBox(true);
        // props.setDialogMessage(t("key-image.titleAlreadyExists"));
        setAlertSuccessModal(()=>{
          const newItem = {...alertSuccessModal};
          newItem.show = true;
          newItem.heading = "Alert";
          newItem.isError = false;
          newItem.isSuccess = false;
          newItem.isWarning = true;
          newItem.description = t("key-image.titleAlreadyExists");
          return newItem;
        });
        action.resetForm();
        return;
      }

      saveKeyImages(props.keyImage.keyImageTitle, values.imageTitle, keyImages, setKeyImages);
      setIsEditable(false);
      action.resetForm();
    },
  });

  const handleReset = () => {
    // values.newImageTitle = props.keyImage.keyImageTitle;
    resetForm();
  };

  const handleDelete = (keyImageTitle) => {
    deleteKeyImages(keyImageTitle, keyImages, setKeyImages);
    setShowDeleteConfirmDialog(false);
  };

  return (
    <>
      <div
        style={{
          width: "97%",
          display: "flex",
          alignItems: "center",
          backgroundColor: "rgb(0,0,0,0.4)",
          borderRadius: "10px",
          padding: "5px 0px",
          // height: "60px",
          marginTop: "10px",
          cursor:"pointer"
        }}
      >
        <div style={{ width: "50%" }}>
          {isEditable ? (
            <>
              <div style={{ width: "80%", marginLeft: "10px" }}>
                <ATextField
                  name="imageTitle"
                  onChange={handleChange}
                  value={values.imageTitle}
                  onBlur={handleBlur}
                  errorMessage={touched.imageTitle && errors.imageTitle}
                />
              </div>
            </>
          ) : (
            <span style={{ color: "#FFFFFF", paddingLeft: "10px" }}>
              {props.keyImage?.keyImageTitle}
            </span>
          )}
        </div>
        <div style={{ width: "30%", display: "flex", alignItems: "center" }}>
          {isEditable ? (
            <>
              <div style={{ marginRight: "10px",display: "flex", alignItems: "center" }} onClick={handleSubmit}>
                <Save />
              </div>
              <div style={{ marginRight: "10px",display: "flex", alignItems: "center" }} onClick={handleReset}>
                <Revert />
              </div>
              <div
                style={{ marginRight: "10px",display: "flex", alignItems: "center" }}
                onClick={() => setIsEditable(false)}
              >
                <Clear />
              </div>
            </>
          ) : (
            <>
              {!isMobile && <div style={{ display: "flex", alignItems: "center" }} onClick={() => setIsEditable(true)}>
                <Edit />{" "}
              </div>}
            </>
          )}
        </div>
        {!isMobile && <div
          style={{ width: "20%", display: "flex" }}
          onClick={() => setShowDeleteConfirmDialog(true)}
        >
          <Delete />
        </div>}
      </div>
      {showDeleteConfirmDialog && (
        <ConfirmModal
          showConfirmModal={showDeleteConfirmDialog}
          title="Confirm"
          handleNotConfirm={() => setShowDeleteConfirmDialog(false)}
          message={t("key-image.delete-message")}
          handleConfirm={() => handleDelete(props.keyImage.keyImageTitle)}
          confirmButtonText={t("button.yes")}
        />
      )}
    </>
  );
};

export default ManageKeyImageRow;
